var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"d-none d-md-block title mt-4"},[_c('b-col',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }